export default __webpack_public_path__ + "static/media/Denim.7786ad71.jpg";